import type { FieldPath } from 'react-hook-form';

import type { ReservationFormInput } from '../schema/reservationForm.schema';

import type { ReservationFormMainEvent } from '../machines/reservationFormMain.types';

export function isFieldEditedWithReservation(
  event: ReservationFormMainEvent,
): event is {
  type: 'FIELD_EDITED';
  reservation: unknown;
  editedField?: FieldPath<ReservationFormInput>;
} {
  return (
    event.type === 'FIELD_EDITED' &&
    'reservation' in event &&
    event.reservation !== undefined &&
    event.reservation !== null
  );
}
